import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import { find as Rfind, propEq as RpropEq } from "ramda";

export default {
  name: "templateWorkOrderEditForm",
  components: {
    FormErrors,
    HmAutocompleteObject,
    LoadingAnimation,
  },
  props: {
    templateWorkOrderId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Template...",
      hasFormErrors: false,
      cancelParams: { name: "templateWorkOrders" },
      formErrors: [],
      templateWorkOrder: {
        name: null,
        description: null,
      },
    };
  },
  created() {
    const jsConnCommodities = new JSConn();
    const jsConn = new JSConn();

    jsConnCommodities.formParams = {};

    const dataPromises = [
      this.$store.dispatch("needCommodities", jsConnCommodities),
    ];

    if (this.templateWorkOrderId === "new") {
      Promise.all(dataPromises).then(() => {
        this.templateWorkOrder = {
          id: uuidv4(),
          template_name: "New",
          template_description: "",
          duration: 5,
          cut_number: 0,
          description: "",
          commodity_id: null,
          commodity: {},
        };
        this.dataLoaded = true;
        this.$nextTick(() => this.$refs.firstInput.select());
        return Promise.resolve();
      });
    } else {
      jsConn.formParams = {
        id: this.templateWorkOrderId,
      };

      dataPromises.push(this.$store.dispatch("needTemplateWorkOrder", jsConn));

      Promise.all(dataPromises).then(() => {
        // correct template work order is in the store
        this.templateWorkOrder = {
          template_name: this.apiTemplateWorkOrder.template_name,
          template_description: this.apiTemplateWorkOrder.template_description,
          description: this.apiTemplateWorkOrder.description,
          duration: this.apiTemplateWorkOrder.duration,
          cut_number: this.apiTemplateWorkOrder.cut_number,
          id: this.apiTemplateWorkOrder.id,
          commodity_id: this.apiTemplateWorkOrder.commodity_id,
          commodity: {},
        };

        // load the commodity
        this.templateWorkOrder.commodity = Rfind(
          RpropEq("value", this.apiTemplateWorkOrder.commodity_id),
          this.commoditiesForAutocomplete,
        );

        this.dataLoaded = true;
        this.cancelParams = {
          name: "templateWorkOrders",
        };
        this.$nextTick(() => this.$refs.firstInput.select());
        return Promise.resolve();
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.formParams = this.templateWorkOrder;
      jsConn.toRoutePath = "/template-work-orders";

      let storeDispatch;

      if (this.templateWorkOrderId === "new") {
        storeDispatch = "createTemplateWorkOrder";
      } else {
        storeDispatch = "updateTemplateWorkOrder";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteTemplateWorkOrder() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/template-work-orders";
      jsConn.formParams = {
        id: this.templateWorkOrderId,
      };
      this.$store.dispatch("deleteTemplateWorkOrder", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
    updateCommodity(evt) {
      this.templateWorkOrder.commodity = evt;
      this.templateWorkOrder.commodity_id = evt.value;
    },
  },
  computed: {
    apiTemplateWorkOrder: function() {
      return this.$store.getters.templateWorkOrder;
    },
    commoditiesForAutocomplete: function() {
      return this.$store.getters.commoditiesForAutocomplete;
    },
  },
};
